import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatIcon } from '@angular/material/icon'

@Component({
  selector: 'ddc-hints-carousel-dialog',
  templateUrl: './ddc-hints-carousel-dialog.component.html',
  styleUrls: ['./ddc-hints-carousel-dialog.component.scss'],
  imports: [MatIcon],
})
export class DdcHintsCarouselDialogComponent {
  currentIndex = 0
  constructor(
    public dialogRef: MatDialogRef<DdcHintsCarouselDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { images: string[] },
  ) {}

  next(): void {
    if (this.data.images.length > 0) {
      this.currentIndex = (this.currentIndex + 1) % this.data.images.length
    }
  }

  prev(): void {
    if (this.data.images.length > 0) {
      this.currentIndex =
        (this.currentIndex - 1 + this.data.images.length) % this.data.images.length
    }
  }

  close(): void {
    this.dialogRef.close()
  }
}
